module.exports = __webpack_public_path__ + "f0cd20cf1c9d4028e4115053e08c070c.MP3";